export function isInWxBrowser() {
    if (!/MicroMessenger/.test(window.navigator.userAgent)) return false;//判断是否是微信客户端
    return true;
}

export function wxAuthorize(appid, state) {
    const redirectUri = `${location.protocol}//${location.host}${location.pathname}`;
    location.replace('https://admin.ue-link.com/platform/wxauthorize?appid=' + appid
        + '&redirectUri=' + encodeURIComponent(redirectUri)
        + '&responseType=code&scope=snsapi_base'
        + '&state=' + encodeURIComponent(state)
        + '#wechat_redirect')

}
